{
  "Login": "Iniciar sesión",
  "Local Login": "Inicio de sesión local",
  "email": "correo electrónico",
  "password": "contraseña"
}
